import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { MetaPageEnum } from '~/core/declaration/declaration';
import { AssetService } from '~/core/services/assets/asset.service';
import { CounterService } from '~/core/services/counter/counter-service';
import { MetaTagService } from '~/core/utils/global-utils/global-utils';
import { HtmlRoutePages } from '../../app-routing.model';
@Component({
  selector: 'volvo-buyers-guide-page',
  templateUrl: './buyers-guide-page.component.html',
  styleUrls: ['./buyers-guide-page.component.scss']
})
export class BuyersGuidePageComponent {
  HtmlRoutePages: HtmlRoutePages;
  link: string = "";
  constructor(private route: ActivatedRoute, private router: Router, private metaTagService: MetaTagService,
    private titleService: Title,
    private translateService: TranslateService,
    private localizeRouterService: LocalizeRouterService,
    private counterService: CounterService,
    public assetService: AssetService) { }
  ngOnInit(): void {
    this.router.events.subscribe(() => {
      this.metaTagService.updateTagFor(MetaPageEnum.BuyersGuide);
    });
    this.metaTagService.updateTagFor(MetaPageEnum.BuyersGuide);
  }

  routePage(type: string): void {

    switch (type) {
      case 'volvoFH16': this.link = HtmlRoutePages.bgvolvoFH16; break;
      case 'volvoFH': this.link = HtmlRoutePages.bgvolvoFH; break;
      case 'volvoFM': this.link = HtmlRoutePages.bgvolvoFM; break;
      case 'volvoFMX': this.link = HtmlRoutePages.bgvolvoFMX; break;
      case 'volvoFE': this.link = HtmlRoutePages.bgvolvoFE; break;
      case 'volvoFL': this.link = HtmlRoutePages.bgvolvoFL; break;
    }
    this.router.navigate([this.localizeRouterService.translateRoute(this.link)], { relativeTo: this.route });
  }


  logTruckModelButtonClick(model: string) {
    this.counterService.postTruckModelClick(model);
  }
}

